<template>
  <div>
    <div class="row">
      <div class="col-12">
        <b-button
          v-b-toggle.collapse-2
          size="sm"
          class="m-1 py-2 btn-choose-program"
          block
          @click="is_open == 1 ? (is_open = false) : (is_open = true)"
          style=""
        >
          Pilih Program
          <i class="fas fa-chevron-down text-white ml-2" v-if="!is_open"></i>
          <i class="fas fa-chevron-up text-white ml-2" v-if="is_open"></i>
        </b-button>
      </div>
    </div>
    <b-collapse id="collapse-2" :visible="visible">
      <div class="card border-0 pt-1">
        <div class="card-body pt-0 px-2">
          <slot name="header"></slot>
          <div class="tab-container my-6">
            <button
              class="tab"
              :class="{ active: activeTab == type.id }"
              @click="setActiveTab(type)"
              v-for="(type, i) in course_types"
              :key="i"
            >
              <!-- <span class="icon">✨</span> -->
              {{ type.name }}
            </button>
          </div>

          <div class="row">
            <div
              class="col-12 col-md-3 mt-6"
              v-for="(course, i) in courses"
              :key="i"
            >
              <div
                :class="{ active: selectedCourseKeyName === course.key_name }"
                class="card card-wrapper"
              >
                <!-- @click="selectCourse(course)" -->
                <!-- Card belakang (dummy) -->
                <!-- <div
                  class="background-card"
                  v-if="selectedCourseKeyName === course.key_name"
                ></div> -->

                <!-- Card utama -->
                <div
                  :class="{ active: selectedCourseKeyName === course.key_name }"
                >
                  <!-- <div
                    class="card-img"
                    :style="{ backgroundImage: `url(${course.product_image})` }"
                  ></div> -->
                  <div class="ct-card-image">
                    <img :src="course.product_image" alt="" />
                  </div>

                  <div
                    class="card-bottom d-flex flex-column"
                    style="min-height: 340px"
                  >
                    <div>
                      <h5 class="title">{{ course.name }}</h5>
                      <!-- <p class="desc">
                        {{
                          course.description.length > 42
                            ? course.description.substring(0, 42) + "..."
                            : course.description
                        }}
                      </p> -->
                      <div class="d-flex align-items-end">
                        <div class="svg-wrapper mr-2 mt-2">
                          <svg
                            aria-hidden="true"
                            class="e-font-icon-svg e-far-calendar-alt"
                            viewBox="0 0 448 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                            ></path>
                          </svg>
                        </div>
                        <div>
                          <span
                            class=""
                            style="
                              color: #52525b;
                              font-size: 13px;
                              font-weight: 500;
                            "
                            >{{ course.info_period }}</span
                          >
                        </div>
                      </div>
                      <div class="d-flex align-items-end">
                        <div class="svg-wrapper mr-2 mt-2">
                          <svg
                            aria-hidden="true"
                            class="e-font-icon-svg e-far-clock"
                            viewBox="0 0 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
                            ></path>
                          </svg>
                        </div>
                        <div>
                          <span
                            class=""
                            style="
                              color: #52525b;
                              font-size: 13px;
                              font-weight: 500;
                            "
                            >{{ course.info_schedule }}</span
                          >
                        </div>
                      </div>
                      <div class="d-flex align-items-end">
                        <div class="svg-wrapper mr-2 mt-2">
                          <svg
                            aria-hidden="true"
                            class="e-font-icon-svg e-fas-chalkboard-teacher"
                            viewBox="0 0 640 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
                            ></path>
                          </svg>
                        </div>
                        <div>
                          <span
                            class=""
                            style="
                              color: #52525b;
                              font-size: 13px;
                              font-weight: 500;
                            "
                            >{{ course.info_session }}</span
                          >
                        </div>
                      </div>
                      <div class="d-flex align-items-end">
                        <div class="svg-wrapper mr-2 mt-2">
                          <svg
                            aria-hidden="true"
                            class="e-font-icon-svg e-fas-graduation-cap"
                            viewBox="0 0 640 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
                            ></path>
                          </svg>
                        </div>
                        <div>
                          <span
                            class=""
                            style="
                              color: #52525b;
                              font-size: 13px;
                              font-weight: 500;
                            "
                            >{{ course.info_certificate }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="mt-6 mb-3">
                      <div
                        class="font-weight-bolder d-flex justify-content-between align-items-center"
                        style="font-size: 14px"
                      >
                        <span class="font-weight-bolder"></span>
                        <span
                          class="font-weight-bolder text-danger"
                          style="color: #52525b"
                        >
                          <strike v-if="course.course_type_id == 1"
                            >Rp. 7.000.000</strike
                          >
                          <strike v-if="course.course_type_id == 2"
                            >Rp. 2.000.000</strike
                          >
                        </span>
                      </div>
                      <div
                        v-for="(price, i) in course.course_prices"
                        :key="i"
                        class="font-weight-bolder d-flex justify-content-between align-items-center"
                        style="font-size: 14px"
                      >
                        <span class="font-weight-bolder">{{
                          price.name == "" ? "Umum" : price.name
                        }}</span>
                        <span class="font-weight-bolder" style="color: #52525b">
                          {{ formattedPrice(course.course_prices[i].price) }}
                        </span>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end mt-auto">
                      <b-button
                        class="register-button px-7"
                        size="sm"
                        @click="
                          $router.push(
                            routePushRegister + '/?course=' + course.key_name
                          )
                        "
                        >Pilih</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <slot name="footer"></slot>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<style scoped>
.svg-wrapper {
  height: 20px;
  width: 20px;
  object-fit: contain;
}
.svg-wrapper svg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.register-button {
  /* background: #f40396;
  border: 3px solid #f40396 !important;
  color: white;
  border-radius: 22px; */
  background-color: #494848;
  font-weight: 500;
  /* fill: #fff; */
  color: #fff;
  /* border-style: solid; */
  border-width: 1px 1px 1px 1px;
  /* border-color: #494848; */
  border: 3px solid #494848 !important;
  border-radius: 20px 20px 20px 20px;
  padding: 8px 20px 8px 20px;
}

.register-button:hover {
  background: #fff !important;
  /* border-color: #494848; */
  color: #494848 !important;
  /* background: #fff !important; */
  /* border: 3px solid #f40396 !important; */
  /* border-color: #f40396 !important; */
  /* color: #f40396 !important; */
}
</style>

<script>
import module from "@/core/modules/CrudModule.js";

export default {
  props: {
    form: {
      type: Object,
      default: {},
    },
    routePushGeneral: {
      type: String,
      default: "/class/register",
    },
    routePushRegister: {
      type: String,
      default: "/class/register",
    },
  },
  data() {
    return {
      courses: [],
      filter: {
        name: "",
        course_type_id: 1,
      },
      course_types: [],
      activeTab: 1,
      selectedCourseKeyName: null,
      is_open: true,
      visible: true,
      is_run: false,
      is_auto_select: false,
    };
  },
  methods: {
    async getPrograms() {
      let filterParams = `&name=${this.filter.name}&course_type_id=${this.filter.course_type_id}`;
      if (!this.$route.query.hasOwnProperty("course")) {
        filterParams += `&workstate_id=8`;
      }
      let response = await module.paginate(
        `api/course-list`,
        `?page=1&page_size=50${filterParams}`
      );
      this.courses = response.data;

      if (this.is_run == false) {
        this.selectedCourseKeyName =
          this.$route.query.hasOwnProperty("course") &&
          this.$route.query.course != ""
            ? this.$route.query.course.replace(/\s+/g, "")
            : this.$route.query.course;

        if (this.$route.query.hasOwnProperty("course")) {
          const findCourse = this.courses.find(
            (course) =>
              course.key_name === this.$route.query.course.replace(/\s+/g, "")
          );
        }
        // this.is_open = true;
        // this.visible = true;
        // this.is_run = true;
      }
    },
    async getCourseTypes() {
      let response = await module.getFullResponse(`api/course-type-list`);
      // If Data Not Found
      if (response == null) {
        // Redirect To List
      } else {
        this.course_types = response.data.data;
      }
    },
    setActiveTab(type) {
      this.activeTab = type.id;
      this.filter.course_type_id = type.id;
      if (
        !this.$route.query.hasOwnProperty("course") ||
        this.$route.query.course === ""
      ) {
        this.getPrograms();
      }
    },
    selectCourse(course) {
      this.selectedCourseKeyName = course.key_name;
      this.$emit("selectCourse", course, true);
    },
    formattedPrice(value) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(value);
    },
    async getProgramByKey() {
      let response = await module.getFullResponse(
        `api/programs-get-by-key/${this.$route.query.course.replace(
          /\s+/g,
          ""
        )}`
      );
      // If Data Not Found
      if (response == null) {
        // Redirect To List
      } else {
        this.selectedCourseKeyName =
          this.$route.query.hasOwnProperty("course") &&
          this.$route.query.course != ""
            ? this.$route.query.course.replace(/\s+/g, "")
            : this.$route.query.course;

        let program = response.data.data;
        this.filter.course_type_id = response.data.data.course_type_id;
        // this.getPrograms();
        let course_type = { id: program.course_type_id };
        this.setActiveTab(course_type);

        if (program.workstate_id == 9) {
          this.$router.push(
            "/class/pre-register?course=" +
              this.$route.query.course.replace(/\s+/g, "")
          );
        }
        this.selectCourse(program);

        this.is_open = true;
        this.visible = true;
        this.is_run = true;
      }
    },
  },
  mounted() {
    // SwalLoading.fire();
    // setTimeout(() => {
    //   let promise;

    // }, 2000);
    if (
      !this.$route.query.hasOwnProperty("course") ||
      this.$route.query.course === ""
    ) {
      this.getPrograms();
    } else {
      this.getProgramByKey();
    }

    this.getCourseTypes();

    this.$root.$on("premiumRegisterSuccess", () => {
      // this.is_open = false;
      this.selectedCourseKeyName = null;
    });
  },
  watch: {
    "$route.query.course"(newVal, oldVal) {
      // setTimeout(() => {
      //   let promise;

      //   // SwalLoading.close();
      // }, 2000);
      if (
        !this.$route.query.hasOwnProperty("course") ||
        this.$route.query.course === ""
      ) {
        this.getPrograms();
      } else {
        this.getProgramByKey();
      }
      this.is_run = false;
    },
  },
};
</script>

<style scoped>
.btn-choose-program {
  background-color: transparent;
  background-image: linear-gradient(
    176deg,
    #292929 72%,
    #f40396 100%
  ) !important;
  color: #fff !important;
}
/* .card-wrapper {
  min-height: 500px;
} */

.background-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #dcdcdc;
  border-radius: 20px;
  z-index: 0;
  transform: none;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.card-wrapper:hover {
  box-shadow: 0 3px 19px rgba(0, 0, 0, 0.2);
}

.card-wrapper.active {
  box-shadow: 0 3px 19px rgba(0, 0, 0, 0.2);
}

.custom-card {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  z-index: 1;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.custom-card.active {
  box-shadow: 0 3px 19px rgba(0, 0, 0, 0.2);
}

.card-img {
  height: 50%;
  background-size: cover;
  background-position: center;
  transition: transform 0.3s ease;
}

.card-bottom {
  padding: 1.2rem;
}

.title {
  font-size: 15px;
  font-weight: bold;
}

.desc {
  font-size: 14px;
  margin-bottom: 1rem;
}

.badge.bg-badge {
  background-color: rgba(206, 15, 15, 0.2);
  font-size: 0.8rem;
  padding: 0.4em 0.7em;
  border-radius: 1rem;
}

.btn {
  font-weight: bold;
}

@media screen and (max-width: 768px) {
  /* .my-col {
    max-width: 100% !important;
  } */
  .custom-card {
    width: 100%;
  }
}
</style>

<style scoped>
/* .my-col {
  max-width: 20%;
} */
.box-title {
  position: relative;
  background: #fff;
  top: -31px;
  /* height: 30px; */
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  width: 90%;
}

.tab-container {
  display: flex;
  gap: 10px;
}

.tab {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: white;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
}

.tab .icon {
  margin-right: 6px;
}

.tab.active {
  background: #ffeef8;
  color: #f40396;
  border: none;
}

.tab:hover:not(.active) {
  border-color: #000;
  color: #000;
}
</style>